export default {
      id: "ukem-energy-logo-usage",
      viewBox: "0 0 145 49",
      url: "/dist/svg/" + "sprite.svg#ukem-energy-logo-usage",
      toString: function () {
        return this.url;
      }
    }